import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { IxToastComponent } from 'ix-ng-components';
import { AppTopBarComponent } from '../topbar/app.topbar.component';
import { AppTopBarBotComponent } from '../topbar-bot/app.topbar-bot.component';
import { FooterComponent } from '../footer/footer.component';

@Component({
  selector: 'lib-javni-layout',
  templateUrl: './javni-layout.html',
  imports: [
    RouterOutlet,
    AppTopBarComponent,
    AppTopBarBotComponent,
    FooterComponent,
    IxToastComponent,
  ],
  styleUrls: ['./layout.scss'],
})
export class JavniLayout {}
